var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSecondaryLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 56 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9221 10.9336L9.45929 28.8572L1 10.9336H4.74717L9.45929 21.1574L14.1779 10.9336H17.9221Z",
    fill: "#1B63CF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9218 3.14307H1.00439V6.28047H17.9218V3.14307Z",
    fill: "#1B63CF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9358 3.14307H38.501V28.4199H41.9358V3.14307Z",
    fill: "#1B63CF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9568 10.9324V6.28101H47.522V10.9324H44.7202V14.0697H47.522V28.4199H50.9568V14.0697C50.9568 14.0697 51.9899 14.0697 52.2525 14.0697C53.0307 14.0697 53.7355 13.6069 54.0804 12.8788C54.2298 12.5635 54.9997 10.9324 54.9997 10.9324H50.9568Z",
    fill: "#1B63CF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7149 10.7556C21.7758 10.7556 17.772 14.7476 17.772 19.6725C17.772 24.5974 21.7758 28.5894 26.7149 28.5894C31.6541 28.5894 35.6579 24.5974 35.6579 19.6725C35.6579 14.7476 31.6541 10.7556 26.7149 10.7556ZM26.7149 25.2413C23.6476 25.2413 21.1617 22.7483 21.1617 19.6725C21.1617 16.5967 23.6482 14.1038 26.7149 14.1038C29.7822 14.1038 32.2681 16.5967 32.2681 19.6725C32.2681 22.7483 29.7817 25.2413 26.7149 25.2413Z",
    fill: "#1B63CF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecondaryLogo);
export default __webpack_public_path__ + "static/media/secondary-logo.c7504825488d660ce98c3c5cdbe9a724.svg";
export { ForwardRef as ReactComponent };